import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faPrint, faCreditCard, faTv, faTabletScreenButton, faLifeRing } from "@fortawesome/pro-light-svg-icons"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { Breadcrumb, StandardBreadcrumbs } from "../../../links/StandardBreadcrumbs"
import { TranslationKey } from "../../../../../modules/localization/translations"
import { useExternalLinks } from "../../../../hooks/useAppLinks"
import { HelpSection } from "./HelpSection"
import { HelpCard } from "./HelpCard"

const useStyles = makeStyles()((theme) => ({
    title: {
        color: theme.palette.tailwind.slate[900],
    },
    iconButton: {
        color: "#2196F3",
        cursor: "pointer",
        display: "inline-block",
        transition: "all .3s ease-in-out",
        "&:hover": {
            transform: "scale(1.2)",
        },
    },
}))

type ListItem = {
    title: string
    icon: IconProp
    id: TranslationKey
    link: string
}
const troubleshootingPosItems: ListItem[] = [
    {
        title: "POS screen not working",
        icon: faTv,
        id: "help-dialog-troubleshooting-pos-screen-not-working",
        link: "https://support.facilitynet.dk/hc/en-dk/articles/18959825694994-Troubleshooting-Guide-for-POS-Terminal-System",
    },
    {
        title: "Printer not working",
        icon: faPrint,
        id: "help-dialog-troubleshooting-printer-not-working",
        link: "https://support.facilitynet.dk/hc/en-dk/articles/18959825694994-Troubleshooting-Guide-for-POS-Terminal-System",
    },
    {
        title: "Credit card terminal not working",
        icon: faCreditCard,
        id: "help-dialog-troubleshooting-credit-card-terminal-not-working",
        link: "https://support.facilitynet.dk/hc/en-dk/articles/18959825694994-Troubleshooting-Guide-for-POS-Terminal-System",
    },
    {
        title: "Start up backup terminal",
        icon: faLifeRing,
        id: "help-dialog-troubleshooting-start-up-backup-terminal",
        link: "https://support.facilitynet.dk/hc/en-dk/articles/18959825694994-Troubleshooting-Guide-for-POS-Terminal-System",
    },
]
const troubleshootingCheckInItems: ListItem[] = [
    {
        title: "Check-in screen not working",
        icon: faTabletScreenButton,
        id: "help-dialog-troubleshooting-check-in-screen-not-working",
        link: "https://support.facilitynet.dk/hc/en-dk/articles/18959825694994-Troubleshooting-Guide-for-POS-Terminal-System",
    },
    {
        title: "Printer not working",
        icon: faPrint,
        id: "help-dialog-troubleshooting-printer-not-working",
        link: "https://support.facilitynet.dk/hc/en-dk/articles/18959825694994-Troubleshooting-Guide-for-POS-Terminal-System",
    },
]

export type TroubleshootingTypeContent = "pos" | "check-in" | null

type TroubleshootingCardsProps = Readonly<{
    type: TroubleshootingTypeContent
    handleBack: (type: TroubleshootingTypeContent) => void
}>

export const TroubleshootingCards = ({ type, handleBack }: TroubleshootingCardsProps) => {
    const { classes } = useStyles()
    const handleExternalLink = useExternalLinks()

    const handleArticleClick = (link: string) => {
        handleExternalLink(link)
    }
    return (
        <Stack gap="3rem">
            <Stack gap="1.5rem">
                <StandardBreadcrumbs>
                    <LocalizedStrict id="help-breadcrumb">
                        <Breadcrumb onClick={() => handleBack(null)} className={classes.iconButton}>
                            Help
                        </Breadcrumb>
                    </LocalizedStrict>
                    <LocalizedStrict id="help-dialog-troubleshooting-breadcrumb">
                        <Breadcrumb>Troubleshooting</Breadcrumb>
                    </LocalizedStrict>
                </StandardBreadcrumbs>

                <LocalizedStrict id="help-dialog-troubleshooting-breadcrumb">
                    <Typography variant="h3" className={classes.title}>
                        Troubleshooting
                    </Typography>
                </LocalizedStrict>
            </Stack>
            {type === "pos" && (
                <LocalizedStrict id="help-dialog-troubleshooting-pos-screen" attrs={{ title: true }}>
                    <HelpSection title="POS screen">
                        {troubleshootingPosItems.map((item) => (
                            <LocalizedStrict id={item.id} attrs={{ title: true }}>
                                <HelpCard
                                    icon={item.icon}
                                    title={item.title}
                                    handleCardClick={() => handleArticleClick(item.link)}
                                />
                            </LocalizedStrict>
                        ))}
                    </HelpSection>
                </LocalizedStrict>
            )}
            {type === "check-in" && (
                <LocalizedStrict id="help-dialog-troubleshooting-check-in-screen" attrs={{ title: true }}>
                    <HelpSection title="Check in screen">
                        {troubleshootingCheckInItems.map((item) => (
                            <LocalizedStrict id={item.id} attrs={{ title: true }}>
                                <HelpCard
                                    icon={item.icon}
                                    title={item.title}
                                    handleCardClick={() => handleArticleClick(item.link)}
                                />
                            </LocalizedStrict>
                        ))}
                    </HelpSection>
                </LocalizedStrict>
            )}
        </Stack>
    )
}
